"use strict";

var _slicedToArray = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/slicedToArray");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */


var react_1 = require("react");

var styles = tslib_1.__importStar(require("./Tab.style"));

var TabItem_1 = tslib_1.__importDefault(require("../TabItem"));

function Tab(_ref) {
  var className = _ref.className,
      tabItems = _ref.tabItems,
      _ref$defaultActiveInd = _ref.defaultActiveIndex,
      defaultActiveIndex = _ref$defaultActiveInd === void 0 ? 0 : _ref$defaultActiveInd,
      _ref$contrast = _ref.contrast,
      contrast = _ref$contrast === void 0 ? false : _ref$contrast,
      onChange = _ref.onChange,
      bordered = _ref.bordered;

  var _react_1$useState = react_1.useState(defaultActiveIndex),
      _react_1$useState2 = _slicedToArray(_react_1$useState, 2),
      activeIndex = _react_1$useState2[0],
      setActiveIndex = _react_1$useState2[1];

  var handleTabItemClick = react_1.useCallback(function (draftTabData) {
    onChange && onChange(draftTabData);
    setActiveIndex(draftTabData.index);
  }, [onChange]);
  react_1.useEffect(function () {
    setActiveIndex(defaultActiveIndex);
  }, [defaultActiveIndex]);
  return jsx_runtime_1.jsx("div", Object.assign({
    role: "tab",
    className: className,
    css: [styles.container, bordered && styles.borderd]
  }, {
    children: tabItems.map(function (tabName, index) {
      return jsx_runtime_1.jsx(TabItem_1.default, {
        index: index,
        name: tabName,
        contrast: contrast,
        active: activeIndex === index,
        onClick: handleTabItemClick
      }, tabName);
    })
  }), void 0);
}

exports.default = react_1.memo(Tab);